"use client"

import { ChevronUp } from "lucide-react"

export default function ScrollToTop() {
  return (
    <button
      onClick={() => {
        const lenis = (window as any).lenis;
        if (lenis) {
          lenis.scrollTo(0, { duration: 1.5 });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }}
      className="fixed bottom-6 right-6 z-[99999] group flex items-center justify-center w-12 h-12 rounded-full bg-black/40 border border-white/10 backdrop-blur-md transition-all duration-300 hover:bg-purple-600/60 hover:-translate-y-1 hover:border-purple-400/50 shadow-[0_0_15px_rgba(0,0,0,0.5)]"
      aria-label="Scroll to top"
    >
      <ChevronUp className="text-white/70 group-hover:text-white transition-colors duration-300 w-6 h-6" />
    </button>
  )
}
